import { AnchorLinkSpan, AnchorLink } from "./styles";
import { withInlineVoidElement } from "../../utils";
const NODE_TYPE = "link";

export default function Link() {
  const plugin = (editor: any) => {
    withInlineVoidElement(editor, "link");
    return editor;
  };

  plugin.renderElement = ({ element, attributes, children }: any) => {
    if (element.type !== NODE_TYPE) {
      return undefined;
    }

    return (
      <AnchorLink
        {...attributes}
        href={element.data.href || element.href || ""}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
        <AnchorLinkSpan contentEditable={false}>{String.fromCodePoint(0)}</AnchorLinkSpan>
      </AnchorLink>
    );
  };

  return plugin;
}
